module.exports = __webpack_public_path__ + "6b64b1097646aabe4e856e8210da908f.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/projekte/theater-2013.jpg
// module id = 816
// module chunks = 0